<template>
  <div class="step5">
    <header-main></header-main>
    <nav-mobile></nav-mobile>
    <section id="order-step5" class="order">
      <header class="main">
        <steps :step="5"></steps>
      </header>
      <div class="wrapper">
        <div class="content">
         <section class="flex">
           <div class="icon">
             <i class="material-icons">done</i>
           </div>
           <h3>Płatność zakończona sukcesem!</h3>
           <h4>Zachęcamy do skorzystania z Panelu Klienta</h4>
           <a class="default" href="https://panel.afk-cob.pl/">Przejdź do Panelu Klienta</a>
         </section>
       </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import FooterMain from '@/components/FooterMain.vue'
import Steps from '@/components/Steps.vue'

export default {
  name: 'Step1',
  components: {
    HeaderMain,
    NavMobile,
    FooterMain,
    Steps,
  },
  data(){
    return{
    }
  },
}
</script>
<style scoped lang="scss">
  section.flex { display: flex; flex-direction: column; align-items: center; }
  div.icon { display: flex; justify-content: center; align-items: center; width: 115px; height: 115px; margin: 0 auto; border-radius: 50%; border: 3px solid $greenLight; }
  div.icon i.material-icons { color: $greenLight; font-size: 45px; }
  h3 { margin: 50px 0; padding: 0; text-align: center; font-weight: 400; font-size: 26px; color: $grayDark; }
  h4 { margin: 0; padding: 0; text-align: center; font-weight: 400; font-size: 18px; color: $grayLight; }
  a.default { margin: 30px 0 0 0; }
</style>
